import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { socialMediaMicrositeAPIService } from '~/api/microsites/social-media';
import { SOCIAL_ICON_ITEMS } from '~/constants/socials';

export const updateSocialSiteThunk = createAsyncThunk(
  'socialMediaSlice/updateSocialThunk',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { socialMediaReducer } = getState();
      const response = await socialMediaMicrositeAPIService.updateSocialMediaSite(
        body,
        socialMediaReducer.micrositeData.id,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateSocialNetworksThunk = createAsyncThunk(
  'socialMediaSlice/updateNetworksThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await socialMediaMicrositeAPIService.createSocialNetworksSite(body);
      } else if (type === 'update') {
        await socialMediaMicrositeAPIService.updateSocialNetworksSite(body.data, body.id);
      } else if (type === 'delete') {
        await socialMediaMicrositeAPIService.deleteSocialNetworksSite(body);
      }
      const response = await socialMediaMicrositeAPIService.getSocialMediaSite(id);

      if (dispatchHandler) {
        dispatchHandler();
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const socialMediaSlice = createSlice({
  name: 'socialMediaSlice',
  initialState: {
    title: '',
    appInformation: {
      head: 'Lorem ipsum dolor',
      description: 'Vestibulum commodo vel risus ac dapibus. Mauris sollicitudin suscipit velit.',
    },
    socialLinks: SOCIAL_ICON_ITEMS.slice(0, 10),
    bacgkroundColor: ['#5356FF'],
    fonts: {
      title: '',
      text: '',
    },
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
    },
    micrositeData: null,
    loading: false,
    error: null,
    micrositeStyles: { container: {} },
    isDeleteSocialLoading: false,
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setBackgroundColor(state, action) {
      state.bacgkroundColor = action.payload;
    },
    setFonts(state, action) {
      state.fonts[action.payload.field] = action.payload.value;
    },
    setAppInformation(state, action) {
      state.appInformation[action.payload.field] = action.payload.value;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setSocialLinks(state, action) {
      state.socialLinks = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setRenderedMicrositeData(state, action) {
      state.appInformation = action.payload.appInformation;
      state.bacgkroundColor = action.payload.bacgkroundColor;
      state.fonts = action.payload.fonts;
      state.socialLinks = action.payload.socialLinks;
      state.micrositeData = action.payload.micrositeData;
      state.stats = action.payload.stats;
    },
    setMicrositeStyles(state, action) {
      state.micrositeStyles = action.payload;
    },
    resetState: () => socialMediaSlice.getInitialState(),
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSocialSiteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSocialSiteThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateSocialSiteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSocialNetworksThunk.pending, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = true;
        }

        state.loading = true;
        state.error = null;
      })
      .addCase(updateSocialNetworksThunk.fulfilled, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }

        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateSocialNetworksThunk.rejected, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }

        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default socialMediaSlice.reducer;
